<script>
import styleHOCFactory from './utils';
export default styleHOCFactory();
</script>

<style module>
@import 'styles/variables.css';

._inputstyle {
  composes: white from global;
  caret-color: var(--green);
  color: white;
  border-radius: 4px;
  background-color: var(--blackOverlay);
  box-shadow: 0 0 6px var(--blackOverlay);
  &:hover {
    color: white;
  }
  &::placeholder {
    text-transform: none;
  }
}
</style>
